<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
::-webkit-scrollbar-button {
  width: 0px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #ddd;
}

body {
  margin: 0;
  padding: 20px;
  background: #f6faff;
  min-width: 1200px;
  overflow: auto;
}
</style>